<template>
  <div class="drop" @dragover.prevent @drop="onDrop">
    <label class="btn display-inline">
      DRAG AND DROP OR
      <input type="file" name="value" ref="fileInput" @change="onChange" />
    </label>
  </div>
</template>

<script>
export default {
  methods: {
    onDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      let files = e.dataTransfer.files
      this.$emit('submit', files[0])
    },
    onChange(e) {
      let files = e.target.files
      this.$emit('submit', files[0])
    },
    clear() {
      this.$refs.fileInput.value = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.drop {
  border: 2px dashed #ccc;
  padding: 40px;
  background-color: #fafafa;
  height: 100%;
  position: relative;
  max-width: 100%;
  text-align: center;
  margin: 0 auto;
}

.drop img {
  max-width: 100%;
}
</style>
